import { render, staticRenderFns } from "./WsInfoColor.vue?vue&type=template&id=1f694300&"
import script from "./WsInfoColor.vue?vue&type=script&lang=js&"
export * from "./WsInfoColor.vue?vue&type=script&lang=js&"
import style0 from "./WsInfoColor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports